import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import NumberParser from "./NumberParser";
import Decimal from "decimal.js-light";
import { DateTime, Settings } from "luxon";
class L10nEngine {
    locale;
    numberParser;
    dateFormat = "dd.MM.yyyy";
    constructor(locale = "da-DK") {
        this.locale = locale;
        this.numberParser = new NumberParser(locale);
    }
    toNumber(n) {
        switch (typeof n) {
            case "number":
                return n;
            case "string":
                return new Decimal(n).toNumber();
            default:
                return n.toNumber();
        }
    }
    asDateTime(d) {
        return (d instanceof DateTime ? d : DateTime.fromISO(d, { setZone: true })).setLocale(this.locale);
    }
    formatNumber(n, decimalPlaces) {
        return new Intl.NumberFormat(this.locale, {
            ...(decimalPlaces !== undefined && {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
            }),
        }).format(this.toNumber(n));
    }
    formatWithExactFractionDigits(n, noOfDigits) {
        return new Intl.NumberFormat(this.locale, {
            minimumFractionDigits: noOfDigits,
            maximumFractionDigits: noOfDigits,
        }).format(typeof n === "number" ? n : typeof n === "string" ? +n : n.toNumber());
    }
    getDateFormat() {
        return this.dateFormat;
    }
    formatPercentage(n) {
        return this.formatWithExactFractionDigits(n, 2) + "%";
    }
    formatCurrency(n) {
        return this.formatWithExactFractionDigits(n, 2);
    }
    formatDateWithWeekdayAndMonthName(d) {
        const text = this.asDateTime(d).toFormat("EEEE d. MMM", {
            locale: Settings.defaultLocale,
        });
        const [weekday, date, monthName] = text.split(" ");
        return [
            weekday.charAt(0).toUpperCase() + weekday.slice(1),
            date,
            monthName.charAt(0).toUpperCase() + monthName.slice(1),
        ].join(" ");
    }
    formatDate(d) {
        return this.asDateTime(d).toFormat(this.dateFormat);
    }
    formatDateAndTime(d) {
        return this.asDateTime(d).toLocaleString(DateTime.DATETIME_SHORT);
    }
    parseNumber(s) {
        return this.numberParser.parse(s);
    }
    parseDecimal(s) {
        return this.numberParser.parseDecimal(s);
    }
    invariantToLocalizedNumberString(input) {
        return input && this.formatNumber(+input);
    }
}
export const LocalizationContext = createContext(new L10nEngine());
export const LocalizationProvider = ({ locale, children, }) => (_jsx(LocalizationContext.Provider, { value: new L10nEngine(locale), children: children }));
export const useL10n = () => useContext(LocalizationContext);
//# sourceMappingURL=LocalizationProvider.js.map